'use strict'

const state = function () {
  return {
    data: false
  }
}

// getters
const getters = {
  data: function (state) {
    return state.data;
  }
}

// actions
const actions = {
  async fetchData({ commit }, { url, params = {} }) {
    return this.client.Get(`${url}`, {
      query: params,
      callback: function (response) {
        commit('data', response);
      }
    });
  },
}

// mutations
const mutations = {
  data (state, payload) {
    state.data = payload;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}